/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServiceTypeModel } from '../../models/service-type-model';

export interface ServiceTypeIdGet$Params {
  id: string;
}

export function serviceTypeIdGet(http: HttpClient, rootUrl: string, params: ServiceTypeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<ServiceTypeModel>> {
  const rb = new RequestBuilder(rootUrl, serviceTypeIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<ServiceTypeModel>;
    })
  );
}

serviceTypeIdGet.PATH = '/ServiceType/{id}';
